document.querySelectorAll('.AgenciesFilters').forEach((el) => {
    el.querySelector('.AgenciesFilters__reset').addEventListener('click', () => {
        el.querySelectorAll('.TagRadioList input').forEach((input) => {
            input.checked = false;
        });
        el.querySelectorAll('.ToggleBase').forEach((el) => {
            el.querySelectorAll('.ToggleBase__item input').forEach((input, i) => {
                input.checked = !i;
                input.dispatchEvent(new CustomEvent('change'));
            });
        });
        el.querySelectorAll('.SearchableInput__input input').forEach((input) => {
            input.value = '';
        });
    });
})
